import { useState } from 'react'
import Tooltip from '@mui/material/Tooltip';
import './styles.css'
function TagsInput({enviarEmails}){
    const [tags, setTags] = useState([])
    const [emailsCopia, emailsCopiaState]  = useState([])
    let [copiaValida, copiaValidaState] = useState(null);
    // let emcopia = [];
    function validateEmailList(emails) {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      
        // const emails = emailList.split(';');
      
        // for (let email of emails) {
          if (!emailRegex.test(emails.trim())) {
                document.getElementById('input-email').disabled=true
            return false;
          }
        // }
        document.getElementById('input-email').disabled=false
        return true;
    }

    function validateEmailList2(emails) {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      
        // const emails = emailList.split(';');
      
        for (let email of emails) {
          if (!emailRegex.test(email.trim())) {
                
            return false;
          }
        }
        document.getElementById('input-email').disabled=false
        return true;
    }
    
   
    function handleKeyDown(e){
        
        var press = e.which || e.keyCode || 0;
        
        if(press !== 32) return
        const value = e.target.value
        console.log(value.indexOf(';'))
        if(!value.trim()) return
        let arrayEmailCopia =  value.split(' ')
        


        var novaArr = arrayEmailCopia.filter(function(este, i) {
            return arrayEmailCopia.indexOf(este) === i;
        });
        // emailsCopia.push(value.split(' '))
    
       
        for(let i in novaArr){
            // console.log(emailsCopia[i] )
            
            tags.push(novaArr[i])
            emailsCopia.push(novaArr[i])
        }

        let invalido =validateEmailList2(emailsCopia);
        
        copiaValida = invalido
       
        copiaValidaState(copiaValida)

        let teste = tags.filter(function(este, i) {
            return tags.indexOf(este) === i;
        });

        let teste2 = emailsCopia.filter(function(este, i) {
            return emailsCopia.indexOf(este) === i;
        });
            setTags([...teste])
        // emailsCopiaState(emcopia)
        
        emailsCopiaState(teste2)
        // console.log(emailsCopia)
        enviarEmails(emailsCopia)
        e.target.value = ''
    }

    function handleBur(e){
        

        const value = e.target.value
        console.log(value.indexOf(' '))
        if(!value.trim()) return
        let arrayEmailCopia =null
        if(value.indexOf(' ') !== -1){
            arrayEmailCopia =  value.split(' ')
        }else if(value.indexOf(';') !== -1){
            arrayEmailCopia =  value.split(';')
        }else if(value.indexOf(',') !== -1){
            arrayEmailCopia =  value.split(',')
        } else{
            arrayEmailCopia =  value.split(' ')
        }



        var novaArr = arrayEmailCopia.filter(function(este, i) {
            return arrayEmailCopia.indexOf(este) === i;
        });
        // emailsCopia.push(value.split(' '))
    
       
        for(let i in novaArr){
            // console.log(emailsCopia[i] )
            
            tags.push(novaArr[i])
            emailsCopia.push(novaArr[i])
        }

        let invalido =validateEmailList2(emailsCopia);
        
        copiaValida = invalido
       
        copiaValidaState(copiaValida)

        let teste = tags.filter(function(este, i) {
            return tags.indexOf(este) === i;
        });

        let teste2 = emailsCopia.filter(function(este, i) {
            return emailsCopia.indexOf(este) === i;
        });
            setTags([...teste])
        // emailsCopiaState(emcopia)
        
        emailsCopiaState(teste2)
        // console.log(emailsCopia)
        enviarEmails(emailsCopia)
        e.target.value = ''
    }

    function removeTag(index){
        setTags(tags.filter((el, i) => i !== index))
        emailsCopia.splice(index, 1)
        emailsCopiaState([...emailsCopia])
        enviarEmails(emailsCopia)
        document.getElementById('input-email').disabled=false
    }

    return (
        <div className="tags-input-container ">
            { tags.map((tag, index) => {
                let valido = validateEmailList(tag)
                
                if(valido){
                    return(
                
                        <div className="tag-item" key={index}>
                            <span className="text" >{tag}</span>
                            <span className="close" onClick={() => removeTag(index)}>&times;</span>
                        </div>
                    )
                }else{
                    
                    return(
                        // <Tooltip title="Email incorreto" arrow>
                            <div className="tag-item-invalid" key={index}>
                                <Tooltip title="Email incorreto" arrow><span className="text" >{tag}</span></Tooltip>
                                <span className="close" onClick={() => removeTag(index)}>&times;</span>
                            </div>
                        // </Tooltip>
                    )
                }
                }) }
            <input 
                onKeyDown={handleKeyDown} 
                id="input-email"    
                type="email" 
                name="email" 
                className="tags-input" 
                placeholder=""
                onBlur={handleBur}
            />
        </div>
    )
}

export default TagsInput